import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { AppConfigService } from '@app/app-config.service';
import { AppStore } from '@app/app.store';
import { MarketingInfo, MarketingInfoService } from '@app/core/services/container/marketing-info.service';
import { LoginStateService } from '@app/features/auth/services/login.state.service';
import { Subject } from 'rxjs';
import { distinctUntilChanged, pluck, switchMap, takeUntil, tap } from 'rxjs/operators';

@Component({
  selector: 'vfs-auth-container',
  templateUrl: './auth-container.component.html',
  styleUrls: ['./auth-container.component.scss']
})
export class AuthContainerComponent implements OnInit, OnDestroy {
  protected destroyed = new Subject();
  public info: MarketingInfo = {
    title: '',
    summary: '',
    url: ''
  };
  public backgroundUrl;

  constructor(
    @Inject('LoginStateService') protected loginStateService: LoginStateService,
    protected appStore: AppStore,
    protected marketingInfoService: MarketingInfoService,
    protected appConfigService: AppConfigService
  ) {
    this.loginStateService.setMarketingInfo(this.info);
  }

  ngOnInit() {
    const assetsFolder = this.appConfigService.isExternal()
      ? `${this.appConfigService.getBlob()}/${this.appConfigService.getEnvName()}`
      : `../../../..`;
    this.backgroundUrl = `${assetsFolder}/assets/features/login/login.png`;
    // We observe the changes in the language, and we obtain the proper data file
    this.appStore.state$
      .pipe(
        takeUntil(this.destroyed),
        pluck('login', 'language'),
        distinctUntilChanged(),
        switchMap(language => this.marketingInfoService.getMarketingInfo(language)),
        tap(info => this.loginStateService.setMarketingInfo(info))
      )
      .subscribe(state => (this.info = state));
  }

  ngOnDestroy() {
    this.destroyed.next();
  }

  openUrl() {
    window.open(this.info.url, '_blank');
  }
}
